import { render, staticRenderFns } from "./PointResult.vue?vue&type=template&id=80f200d4&"
import script from "./PointResult.vue?vue&type=script&lang=js&"
export * from "./PointResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports